import { render, staticRenderFns } from "./SquarePassport.vue?vue&type=template&id=78f15ef2&scoped=true"
import script from "./SquarePassport.vue?vue&type=script&lang=js"
export * from "./SquarePassport.vue?vue&type=script&lang=js"
import style0 from "./SquarePassport.vue?vue&type=style&index=0&id=78f15ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f15ef2",
  null
  
)

export default component.exports